import Content from "../component/Content";
import Toolcard from "../component/Toolcard";
import './atctools.css';

const ATCTools = () => {

    return (
        <div>
            <Content
                left={
                    <p></p>
                }  
                center={
                    <ul className="toolList">
                        <li>
                            <Toolcard
                                url={
                                    "http://atctools.freike.de"
                                }
                                toolname={
                                    'BASIC Tower Stripboard (from FVK354 on)'
                                }
                                description = {
                                    'A stripboard that can be used for training of stripmovement and striphandling in the DFS Basic Tower course. \
                                    All basic controls are implemented, e.g. stripmovement between different bays, writing into strips, changing colors and generating random IFR-Strips.'
                                }
                                author={
                                    'Freike'
                                }
                                version={
                                    'v0.9'
                                }
                                update={
                                    '01.11.2024'
                                }
                            />
                        </li>
                        <li>
                            <Toolcard
                                url={
                                    "./radarsim"
                                }
                                toolname={
                                    'BASIC Radar Stripboard (from FVK354 on)'
                                }
                                description = {
                                    'Not started yet'
                                }
                                author={
                                    'Freike'
                                }
                                version={
                                    'v0'
                                }
                                update={
                                    '-'
                                }
                            />
                        </li>
                    </ul>
                } 
                right={
                    <p></p>
                }   
            />
        </div>
    )
}

export default ATCTools;